import { ReceiptDetailDto } from "../../store/models/CustomerInteractionDto";

export const receiptDetailExamplesMarcopolo: ReceiptDetailDto[] = [
  {
    amount: "1.000",
    salesPrice: "249.95",
    originalPrice: "249.95",
    itemInfo: {
      productGroupNumber: 3000,
      productGroupDesc: "MO’P Denim",
      subGroupNumber: 300030,
      subGroupDesc: "Mäntel",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "Wattiertes Barnjacket oversize aus Waxed-Organic-Cotton-Nylon-Mix",
      refNumber: "MOP001",
      rating: 5,
      votings: 231,
      organic: true,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "37690100",
    },
  },
  {
    amount: "1.000",
    salesPrice: "249.95",
    originalPrice: "249.95",
    itemInfo: {
      productGroupNumber: 3000,
      productGroupDesc: "Taschen",
      subGroupNumber: 300020,
      subGroupDesc: "Shopper",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "Shopper medium aus genarbtem Rindleder",
      refNumber: "MOP002",
      rating: 5,
      votings: 14,
      organic: false,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "4049602357187",
    },
  },
  {
    amount: "1.000",
    salesPrice: "139.95",
    originalPrice: "139.95",
    itemInfo: {
      productGroupNumber: 3000,
      productGroupDesc: "Bekleidung",
      subGroupNumber: 300010,
      subGroupDesc: "Röcke",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "A-Linien-Rock aus LENZING™ ECOVERO™",
      refNumber: "MOP003",
      rating: 4.5,
      votings: 15,
      organic: true,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "40412357187",
    },
  },
  {
    amount: "1.000",
    salesPrice: "279.95",
    originalPrice: "279.95",
    itemInfo: {
      productGroupNumber: 3000,
      productGroupDesc: "Boots",
      subGroupNumber: 300040,
      subGroupDesc: "Long Boots",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "Langschaft-Stiefel mit höherem Absatz",
      refNumber: "MOP004",
      rating: 4.5,
      votings: 8,
      organic: false,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "37690101",
    },
  },
  {
    amount: "1.000",
    salesPrice: "79.95",
    originalPrice: "79.95",
    itemInfo: {
      productGroupNumber: 2000,
      productGroupDesc: "Hemden",
      subGroupNumber: 200020,
      subGroupDesc: "Langarm",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "Hemd regular aus weichem Bio-Baumwoll-Flanell",
      refNumber: "MOP005",
      rating: 4.5,
      votings: 10,
      organic: true,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "4049602357188",
    },
  },
  {
    amount: "1.000",
    salesPrice: "119.95",
    originalPrice: "119.95",
    itemInfo: {
      productGroupNumber: 4000,
      productGroupDesc: "Jeans",
      subGroupNumber: 400020,
      subGroupDesc: "StraightFit",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "Jeans Model Kalmo straight made with CIRCULOSE®",
      refNumber: "MOP006",
      rating: 5,
      votings: 231,
      organic: false,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "40412357189",
    },
  },
  {
    amount: "1.000",
    salesPrice: "149.95",
    originalPrice: "149.95",
    itemInfo: {
      productGroupNumber: 3000,
      productGroupDesc: "Bekleidung",
      subGroupNumber: 300050,
      subGroupDesc: "Steppjacken",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "KIDS-GIRLS Steppjacke mit extra Länge",
      refNumber: "MOP007",
      rating: 5,
      votings: 7,
      organic: true,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "453976856",
    },
  },
  {
    amount: "1.000",
    salesPrice: "49.95",
    originalPrice: "49.95",
    itemInfo: {
      productGroupNumber: 2000,
      productGroupDesc: "Bekleidung",
      subGroupNumber: 200010,
      subGroupDesc: "Kleid",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "KIDS-GIRLS Kleid mit zartem Blumenprint",
      refNumber: "MOP008",
      rating: 4.5,
      votings: 13,
      organic: false,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "3456897345789",
    },
  },
  {
    amount: "1.000",
    salesPrice: "29.95",
    originalPrice: "29.95",
    itemInfo: {
      productGroupNumber: 3000,
      productGroupDesc: "Bekleidung",
      subGroupNumber: 300060,
      subGroupDesc: "Leggings",
      supplierNumber: 2022,
      supplierDesc: "Marc O'Polo",
      supplierItemText: "KIDS-GIRLS Thermoleggings aus warmem Baumwoll-Mix",
      refNumber: "MOP009",
      rating: 4,
      votings: 1,
      organic: false,
      salesAreaNumber: 123,
      salesAreaDesc: "salesAreaDesc",
      ean: "3456897345780",
    },
  },
];
